import { FilterActions, FilterVariant } from "@next-platform/client-common-spicy-ui";
import { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";

import { CHAT_SIZE_OPTIONS } from "@/constants/chatSize";

const toVariant = ({ isRefined, isExcluded }: { isRefined?: boolean; isExcluded?: boolean }) => {
  if (isExcluded) return FilterVariant.EXCLUDE;
  if (isRefined) return FilterVariant.INCLUDE;
  return FilterVariant.DEFAULT;
};

const normalizeChatSizeName = (value: string): string => {
  const option = Object.values(CHAT_SIZE_OPTIONS).find((opt) => opt.value === value);
  return option?.name || value;
};

export default function generateChatSizeData(
  items: RefinementListItem[],
  actionHandler: (action: FilterActions, value?: string) => void,
  translateLabel: (sizeSource: string) => string,
) {
  const sorted = items.slice().sort((itemA, itemB) => {
    if ((itemB.count ?? 0) !== (itemA.count ?? 0)) return (itemB.count ?? 0) - (itemA.count ?? 0);
    return normalizeChatSizeName(itemA.label).localeCompare(normalizeChatSizeName(itemB.label));
  });

  return sorted.map((refinementListItem: RefinementListItem) => {
    const sizeSource = refinementListItem.value || normalizeChatSizeName(refinementListItem.label);
    const label = translateLabel(sizeSource);
    const count = refinementListItem.count ?? 0;
    return {
      label,
      count,
      value: refinementListItem.value,
      variant: toVariant(refinementListItem),
      disabled: count === 0,
      actionHandler,
    };
  });
}
